const publicFundsChange = [{
        path: "/publicHome",
        name: "公募首页",
        component: () => import("@views/publicFundsChange/publicHome/index.vue"),
        meta: {
            title: "",
            singleHead: true,
            keepAlive:true,
        },
    },
    {
        path: "/homeImge",
        name: "图片详情",
        component: () => import("@views/publicFundsChange/publicHome/HomeImge.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/basicDiskIndex",
        name: "基本盘",
        component: () => import("@views/publicFundsChange/basicDisk/index.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/toolCaseIndex",
        name: "工具箱",
        component: () => import("@views/publicFundsChange/toolCase/index.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    }, {
        path: "/test",
        name: "测试页",
        component: () => import("@views/publicFundsChange/toolCase/test.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    }, {
        path: "/test1",
        name: "测试页",
        component: () => import("@views/publicFundsChange/toolCase/test1.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    }, {
        path: "/test2",
        name: "测试页",
        component: () => import("@views/publicFundsChange/toolCase/test2.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    }, {
        path: "/moneyFundIndex",
        name: "货币基金",
        component: () => import("@views/publicFundsChange/moneyFund/index.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    }, {
        path: "/newFundIndex",
        name: "新发基金",
        component: () => import("@views/publicFundsChange/newFund/index.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    }, {
        path: "/timeInvestIndex",
        name: "省心定投",
        component: () => import("@views/publicFundsChange/timeInvest/indexNew.vue"),
        meta: {
            title: "",
            singleHead: true,

        },
    }, {
        path: "/fundScreening",
        name: "基金筛选",
        component: () => import("@views/publicFundsChange/fundScreening/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },{
        path: "/screening",
        name: "基金筛选",
        component: () => import("@views/publicFundsChange/fundScreening/fundScreening.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/screenshotScreening",
        name: "基金筛选截图",
        component: () => import("@views/publicFundsChange/fundScreening/screenshotScreening.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/windIndicator",
        name: "风向标",
        component: () => import("@views/publicFundsChange/windIndicator/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    }, {
        path: "/stockAndbondFullscreen",
        name: "股债利差",
        component: () => import("@views/publicFundsChange/windIndicator/components/StockAndBondFullscreen.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    }, {
        path: "/weatherglass",
        name: "温度计",
        component: () => import("@views/publicFundsChange/windIndicator/weatherglass/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    //分享风向标
    {
        path: "/windIndicatorPreviewData",
        name: "风向标",
        component: () => import("@views/publicFundsChange/preview/windIndicatorPreview/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    //分享温度计
    {
        path: "/weatherglassPreviewData",
        name: "温度计",
        component: () => import("@views/publicFundsChange/preview/windIndicatorPreview/weatherglass/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/publicList",
        name: "公募榜单",
        component: () => import("@views/publicFundsChange/publicList/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    }, {
        //预览
        path: "/econView",
        name: "财经早餐",
        component: () => import("@views/publicFundsChange/econ-view/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    }, {
        //分享-详情、App-详情
        path: "/economicsBreackfast",
        name: "财经早餐",
        component: () => import("@views/publicFundsChange/economicsBreackfast/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    }, {
        path: "/downloadAppPage",
        name: "陆享基金",
        component: () => import("@views/publicFundsChange/downloadAppPage/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/fundContrast",
        name: "基金对比",
        component: () => import("@views/publicFundsChange/fundContrast/second.vue"),
        meta: {
            title: "",
            singleHead: true,
            keepAlive: true,
        },
    },
    {
        path: "/deleteContrastFund",
        name: "删除基金",
        component: () => import("@views/publicFundsChange/fundContrast/delete.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/searchFund",
        name: "搜索",
        component: () => import("@views/publicFundsChange/fundContrast/search.vue"),
        meta: {
            title: "",
            singleHead: true,
            keepAlive: true,
        },
    },
    {
        path: "/searchMoreFund",
        name: "搜索更多",
        component: () => import("@views/publicFundsChange/fundContrast/searchMore.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/basicDiskPreview", //基本盘预览
        name: "基本盘",
        component: () => import("@views/publicFundsChange/preview/basicDiskPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/publicHomePreview",//首页预览--生效前
        name: "首页预览",
        component: () => import("@views/publicFundsChange/preview/publicHomePreview/index.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/publicHomePreview1",//首页预览--生效后
        name: "首页预览",
        component: () => import("@views/publicFundsChange/preview/publicHomePreview/index1.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/publicListPreview",//公募榜单预览
        name: "公募榜单预览",
        component: () => import("@views/publicFundsChange/preview/publicListPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/screeningPreview",//筛选预览
        name: "筛选预览预览",
        component: () => import("@views/publicFundsChange/preview/fundScreeningPreview/index.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/toolCasePreview",//工具箱预览
        name: "工具箱",
        component: () => import("@views/publicFundsChange/preview/toolCasePreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/publicDetailPreview", //产品详情预览
        name: "详情",
        component: () => import("@views/publicFundsChange/preview/publicDetailPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/newFundDetailPreview", //新发产品详情预览
        name: "详情",
        component: () => import("@views/publicFundsChange/preview/newFundDetailPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/newFundPreview", //新发基金预览
        name: "新发基金",
        component: () => import("@views/publicFundsChange/preview/newFundPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/moneyFundPreview", //货币基金预览
        name: "货币基金",
        component: () => import("@views/publicFundsChange/preview/moneyFundPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/timeInvestPreview", //省心定投预览
        name: "省心定投",
        component: () => import("@views/publicFundsChange/preview/timeInvestPreview/indexNew.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/pursueIncome",
        name: "追求收益",
        component: () => import("@views/publicFundsChange/pursueIncome/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/manageMoney",
        name: "稳健理财",
        component: () => import("@views/publicFundsChange/manageMoney/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/pursueIncomePreview",
        name: "追求收益-预览",
        component: () => import("@views/publicFundsChange/preview/pursueIncomePreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/windIndicatorPreview", //风向标预览
        name: "风向标",
        component: () => import("@views/publicFundsChange/preview/windIndicatorPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/weatherGlassPreview", //温度计预览 
        name: "温度计",
        component: () => import("@views/publicFundsChange/preview/weatherGlassPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/manageMoneyPreview",
        name: "稳健理财-预览",
        component: () => import("@views/publicFundsChange/preview/manageMoneyPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/fundComparison",
        component: () => import("@views/publicFundsChange/fundComparison/index.vue"),
        meta: {
            title: "基金对比",
            singleHead: true
        },
    },
    {
        path: "/performance-chart",
        name: "业绩走势图",
        component: () => import("@/components/charts/PerformanceChartPage.vue"),
        meta: {
            title: "业绩走势图",
            singleHead: true
        }
    },
    {
        path: "/myChoice",
        component: () => import("@views/publicFundsChange/myChoiceFund/index.vue"),
        meta: {
            title: "我的自选",
            singleHead: true
        },
    },
    {
        path: "/themeSelectFund",
        name: "主题选基",
        component: () => import("@views/publicFundsChange/themeSelectFund/index.vue"),
        meta: {
            title: "主题选基",
            singleHead: true,
            keepAlive: true,
            useCatch: false //是否用缓存
        }
    },
    {
        path: "/exponentialSelectFund",
        name: "指数选基",
        component: () => import("@views/publicFundsChange/exponentialSelectFund/index.vue"),
        meta: {
            title: "指数选基",
            singleHead: true,
            keepAlive: true,
            useCatch: false //是否用缓存
        }
    },
    {
        path: "/comSearch",
        name: "股票搜索",
        component: () => import("@views/publicFundsChange/components/comSearch.vue"),
        meta: {
            title: "股票搜索",
            singleHead: true
        }
    },
    {
        path: "/comSearchDetail",
        name: "搜索更多",
        component: () => import("@views/publicFundsChange/components/comSearchDetail.vue"),
        meta: {
            title: "搜索更多",
            singleHead: true
        }
    },
    {
        path: "/themeDetail",
        name: "主题选基",
        component: () => import("@views/publicFundsChange/themeSelectFund/detail.vue"),
        meta: {
            title: "主题选基",
            singleHead: true
        }
    },
    {
        path: "/stockSearchFund",
        name: "股票选基",
        component: () => import("@views/publicFundsChange/stockSelectFund/index.vue"),
        meta: {
            title: "",
            singleHead: true
        }
    },
    {
        path: "/stockResult",
        name: "选基结果",
        component: () => import("@views/publicFundsChange/stockSelectFund/stockResult.vue"),
        meta: {
            title: "",
            singleHead: true,
            keepAlive: true
        }
    },
    {
        path: "/themePreview", //主题选基预览
        name: "主题选基预览",
        component: () => import("@views/publicFundsChange/preview/themePreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/exponentialPreview", //指数选基预览
        name: "指数选基预览",
        component: () => import("@views/publicFundsChange/preview/exponentialPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/stockSelectFundPreview", // 股票选基预览
        name: "股票选基",
        component: () => import("@views/publicFundsChange/preview/stockSelectFundPreview.vue"),
        meta: {
            title: "",
            singleHead: true
        }
    },
    {
        path: "/lupuObserve", // 陆浦观察
        name: "陆浦观察",
        component: () => import("@views/publicFundsChange/lupuObserve/index.vue"),
        meta: {
            title: "",
            singleHead: true,
        }
    },
    {
        path: "/lupuObserveDetail",
        name: "陆浦观察",
        component: () => import("@views/publicFundsChange/lupuObserve/detail.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        //预览
        path: "/lupuObservePreview",
        name: "陆浦观察",
        component: () => import("@views/publicFundsChange/preview/lupuObservePreview.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/shoppingCartIndex",
        name: "批量买基金",
        component: () => import("@views/publicFundsChange/shoppingCart/index.vue"),
        meta: {
            title: "",
            singleHead: true,
            keepAlive:true
        },
    },
    {
        path: "/shoppingCartModule",
        name: "购物车",
        component: () => import("@views/publicFundsChange/shoppingCartModule/index.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/addShoppingCart",
        name: "添加基金",
        component: () => import("@views/publicFundsChange/shoppingCartModule/addShoppingCart.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/searchFundList",
        name: "搜索基金",
        component: () => import("@views/publicFundsChange/shoppingCartModule/search.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/allQueryResultCart",
        name: "搜索更多",
        component: () => import("@views/publicFundsChange/shoppingCartModule/searchMore.vue"),
        meta: {
            title: "",
            singleHead: true,
        },
    },
    {
        path: "/bulkBuying",
        name: "批量买入",
        component: () => import("@views/publicFundsChange/shoppingCart/bulkBuying.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/batchRulesPage",
        name: "批量买入交易规则",
        component: () => import("@views/publicFundsChange/shoppingCart/batchRulesPage.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/shoppingCarShare",
        name: "购物车分享",
        component: () => import("@views/publicFundsChange/shoppingCart/sharePage.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/shoppingCarLogin",
        name: "验证手机号",
        component: () => import("@views/publicFundsChange/shoppingCart/shareLogin.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {
        path: "/addShoppingCartPreview",
        name: "添加基金-投研推荐预览",
        component: () => import("@views/publicFundsChange/preview/shoppingCart/addShoppingCartPreview.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {// 产品营销-预览
        path: "/productMarketingPreview",
        name: "",
        component: () => import("@views/publicFundsChange/preview/productMarketingPreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        }
    },
    {// 营销页
        path: "/productMarketing",
        name: "",
        component: () => import("@views/publicFundsChange/preview/productMarketing.vue"),
        meta: {
            title: "",
            singleHead: true,
        }
    },
    {
        path: "/shareScreening",
        name: "基金筛选",
        component: () => import("@views/publicFundsChange/fundScreening/shareScreening.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
    {// 产品营销-图片预览
        path: "/imagePreview",
        name: "",
        component: () => import("@views/publicFundsChange/preview/imagePreview.vue"),
        meta: {
            title: "",
            singleHead: true,
        }
    },
    {
        path: "/calendar",
        name: "更多开放时间",
        component: () => import("@views/publicFundsChange/calendar/index.vue"),
        meta: {
            title: "",
            singleHead: true
        },
    },
]
export default publicFundsChange